// extracted by mini-css-extract-plugin
export var descriptiveCardWrapper = "descriptiveSlider-module--descriptiveCardWrapper--a35a3";
export var descriptiveSlider = "descriptiveSlider-module--descriptive-slider--e5541";
export var overlay = "descriptiveSlider-module--overlay--05ac7";
export var slideWrapper = "descriptiveSlider-module--slide-wrapper--48aee";
export var slider = "descriptiveSlider-module--slider--cd0e5";